module.exports = __webpack_public_path__ + "static/media/about.99febc6c.jpg";